import React from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import ErrorPage from "./ErrorPage";

const NotFound = ({ showHomeButton }) => {
  return (
    <ErrorPage
      code="404"
      title="GENERIC_PAGE_NOT_FOUND_TITLE"
      message="GENERIC_PAGE_NOT_FOUND_MESSAGE"
      showHomeButton={showHomeButton}
    />
  );
};

NotFound.propTypes = {
  showHomeButton: PropTypes.bool,
};

NotFound.defaultProps = {
  showHomeButton: false,
};

export default withTranslation()(NotFound);
